import React from 'react';
import { X } from 'lucide-react';
import PropTypes from 'prop-types';

// props: title, onClose, onConfirm, isLoading
const DeleteModal = ({ title = 'Are you sure you want to delete?', onClose, onConfirm, isLoading = false }) => {
    // Backdrop click closes modal
    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };
    return (
        <div
            onClick={handleBackdropClick}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[9999] p-4 animate-fade-in"
        >
            <style>{`
                @keyframes fade-in {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                @keyframes slide-up {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                .animate-fade-in {
                    animation: fade-in 0.2s ease-out;
                }
                .animate-slide-up {
                    animation: slide-up 0.3s ease-out;
                }
            `}</style>
            <div className="bg-white rounded-xl w-full max-w-md max-h-[90vh] overflow-hidden shadow-2xl flex flex-col animate-slide-up">
                {/* Header */}
                <div className="px-8 py-6 border-b border-gray-200 flex justify-between items-center">
                    <h3 className="text-xl font-semibold text-gray-900 m-0">{title}</h3>
                    <button
                        onClick={onClose}
                        disabled={isLoading}
                        className="w-8 h-8 rounded-md flex items-center justify-center p-0 border-0 bg-transparent hover:bg-gray-100 transition-all duration-200 hover:rotate-90"
                        aria-label="Close"
                    >
                        <X size={20} className="text-gray-600" />
                    </button>
                </div>
                {/* Content */}
                <div className="flex-1 px-8 py-4 text-center flex flex-col items-center justify-center">
                    <div className="flex justify-center gap-4 w-full">
                        <button
                            type="button"
                            onClick={onClose}
                            disabled={isLoading}
                            className="px-6 py-2.5 rounded-lg border-2 border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 hover:-translate-y-0.5 hover:shadow-lg transition-all duration-200 active:translate-y-0"
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            onClick={onConfirm}
                            disabled={isLoading}
                            className="px-7 py-2.5 rounded-lg border-0 bg-gradient-to-br from-red-600 to-red-700 text-sm font-medium text-white hover:from-red-700 hover:to-red-800 hover:-translate-y-0.5 hover:shadow-lg transition-all duration-200 active:translate-y-0"
                        >
                            {isLoading ? 'Deleting...' : 'Yes, Delete'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

DeleteModal.propTypes = {
    title: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
};

export default DeleteModal;
